// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login_rootContainer__peznh {
  direction: rtl !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding-block: 25px !important;
  height: 100vh !important;
}
.Login_container__YLBHG {
  height: 100% !important;
  padding-inline: 25px !important;
}
.Login_carouselPart__P20zU {
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.Login_carouselContainer__6jBlf {
  width: 100%;
  height: 100%;
  /* padding: 0 30px; */
}
.Login_formPart__3iTvF {
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  direction: ltr !important;
  overflow-y: auto !important;
}
.Login_borderedContainer__6KWGe {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  /* border: 1px solid #e5e5e5 !important; */
  border-radius: 10px !important;
  min-height: 400px !important;
  padding-block: 10px 30px !important;
  position: relative !important;
  transition: all 0.3s ease-out !important;
  direction: rtl !important;
}
.Login_loginInfosContainer__lqR6u {
  display: flex !important;
  align-items: flex-start !important;
  justify-content: center !important;
  flex-direction: column !important;
}
.Login_formWrapper__6-F46 {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  row-gap: 40px !important;
  width: 100% !important;
}
.Login_welcomeTitle__H5oZ5 {
  padding-block-end: 60px;
  font-weight: 700;
  font-size: 60px;
}
.Login_welcomeText__8zTrN {
  font-weight: 400;
  font-size: 19px;
  color: #737373;
  padding-block-end: 24px;
  text-align: justify;
  hyphens: auto;
}
.Login_inputContainer__VBrGJ {
  width: 100%;
}
.Login_submitGrid__Pvf7e {
  margin-block-start: 50px !important;
}
.Login_loginReqBtnContainer__kRSTt {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-top: 55px;
}
.Login_actionBtnsContainer__xCKyL {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 65px;
}
.Login_returnContainer__\\+eOCD {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.Login_submitBtnsContainer__VYDc4 {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.Login_returnBtn__lh2UF {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 5px;
  color: var(--focused-input-color);
  fill: var(--focused-input-color);
  border-radius: 9px;
  padding: 5px 10px;
  /* width: 80px;
  height: 40px; */
  cursor: pointer;
  font-size: 15px;
  font-weight: 400;
}
.Login_returnBtn__lh2UF svg {
  width: 24px;
  height: 24px;
  transform: rotate(180deg);
}
.Login_submitBtn__5ZKOw {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--focused-input-color);
  color: #ffffff;
  fill: #ffffff;
  border-radius: 9px;
  padding: 12px 8px;
  /* width: 80px;
  height: 40px; */
  min-width: 80px;
  column-gap: 8px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  min-width: 125px;
}
.Login_submitBtn__5ZKOw:after {
  background: #fff9f9;
  content: "";
  height: 155px;
  left: -75px;
  opacity: 0.2;
  position: absolute;
  top: -50px;
  transform: rotate(35deg);
  transition: all 1s cubic-bezier(0.19, 1, 0.22, 1);
  width: 50px;
  z-index: 0;
}

.Login_submitBtn__5ZKOw:hover:after {
  left: 120%;
  transition: all 1s cubic-bezier(0.19, 1, 0.22, 1);
}
.Login_submitTxt__z1Im8 {
  font-size: 16px;
  font-weight: 500;
}
.Login_sendAgainTxt__ku0S3 {
  font-size: 14px;
  font-weight: 400;
}
.Login_submitBtn__5ZKOw svg {
  width: 24px;
  height: 24px;
}
.Login_otpAbsolutePosition__x9bDc {
  position: absolute !important;
  top: 0 !important;
  right: 0 !important;
  width: 100% !important;
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.Login_otpContainer__28HNE {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-direction: column !important;
  row-gap: 20px !important;
}
.Login_otpMounted__\\+Izmu {
  animation: Login_otpIn__0ZZrD 350ms ease-in;
}
.Login_otpUnmounted__D\\+cRM {
  animation: Login_otpOut__i7Im2 390ms ease-out forwards;
}
@keyframes Login_otpOut__i7Im2 {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes Login_otpIn__0ZZrD {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.Login_countDownContainer__QTU-p {
  padding-inline-end: 12px;
  color: #737373;
}
.Login_progress__98HmO {
  width: 24px !important;
  height: 24px !important;
  color: #fff !important;
}
@media all and (max-width: 900px) {
  .Login_welcomeTitle__H5oZ5 {
    padding-block-end: 70px;
    font-size: 48px;
  }
  .Login_formPart__3iTvF {
    justify-content: flex-end !important;
  }
}
@media all and (max-width: 600px) {
  .Login_formPart__3iTvF {
    justify-content: center !important;
  }
  .Login_carouselPart__P20zU {
    /* display: none !important; */
    position: fixed !important;
    top: 0;
    right: 0;
    z-index: -1;
  }
  .Login_welcomeTitle__H5oZ5 {
    padding-block-end: 60px;
    font-weight: 700;
    font-size: 40px;
  }
  .Login_welcomeText__8zTrN {
    font-size: 18px;
    padding-block-end: 24px;
  }
  .Login_borderedContainer__6KWGe {
    background-color: #ffffffe5;
    padding-block: 70px;
    padding-inline: 20px;
  }
  .Login_container__YLBHG {
    padding-inline: 0 !important;
  }
  .Login_submitBtn__5ZKOw {
    min-width: 120;
  }
}
@media all and (max-width: 400px) {
  .Login_welcomeTitle__H5oZ5 {
    padding-block-end: 40px;
    font-weight: 700;
    font-size: 32px;
  }
  .Login_welcomeText__8zTrN {
    font-size: 16px;
    padding-block-end: 20px;
  }
  .Login_submitBtn__5ZKOw {
    min-width: 100px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Login/Login.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,0CAA0C;EAC1C,8BAA8B;EAC9B,4BAA4B;EAC5B,mCAAmC;EACnC,6BAA6B;EAC7B,wCAAwC;EACxC,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,kCAAkC;EAClC,iCAAiC;AACnC;AACA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;EACjC,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB;iBACe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB;iBACe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,iDAAiD;EACjD,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iDAAiD;AACnD;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,iCAAiC;EACjC,wBAAwB;AAC1B;AACA;EACE,2CAA8B;AAChC;AACA;EACE,sDAAyC;AAC3C;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE;IACE,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,oCAAoC;EACtC;AACF;AACA;EACE;IACE,kCAAkC;EACpC;EACA;IACE,8BAA8B;IAC9B,0BAA0B;IAC1B,MAAM;IACN,QAAQ;IACR,WAAW;EACb;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,2BAA2B;IAC3B,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".rootContainer {\r\n  direction: rtl !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  padding-block: 25px !important;\r\n  height: 100vh !important;\r\n}\r\n.container {\r\n  height: 100% !important;\r\n  padding-inline: 25px !important;\r\n}\r\n.carouselPart {\r\n  height: 100% !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n}\r\n.carouselContainer {\r\n  width: 100%;\r\n  height: 100%;\r\n  /* padding: 0 30px; */\r\n}\r\n.formPart {\r\n  height: 100% !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  direction: ltr !important;\r\n  overflow-y: auto !important;\r\n}\r\n.borderedContainer {\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  /* border: 1px solid #e5e5e5 !important; */\r\n  border-radius: 10px !important;\r\n  min-height: 400px !important;\r\n  padding-block: 10px 30px !important;\r\n  position: relative !important;\r\n  transition: all 0.3s ease-out !important;\r\n  direction: rtl !important;\r\n}\r\n.loginInfosContainer {\r\n  display: flex !important;\r\n  align-items: flex-start !important;\r\n  justify-content: center !important;\r\n  flex-direction: column !important;\r\n}\r\n.formWrapper {\r\n  display: flex !important;\r\n  flex-direction: column !important;\r\n  align-items: flex-start !important;\r\n  row-gap: 40px !important;\r\n  width: 100% !important;\r\n}\r\n.welcomeTitle {\r\n  padding-block-end: 60px;\r\n  font-weight: 700;\r\n  font-size: 60px;\r\n}\r\n.welcomeText {\r\n  font-weight: 400;\r\n  font-size: 19px;\r\n  color: #737373;\r\n  padding-block-end: 24px;\r\n  text-align: justify;\r\n  hyphens: auto;\r\n}\r\n.inputContainer {\r\n  width: 100%;\r\n}\r\n.submitGrid {\r\n  margin-block-start: 50px !important;\r\n}\r\n.loginReqBtnContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  width: 100%;\r\n  margin-top: 55px;\r\n}\r\n.actionBtnsContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  margin-top: 65px;\r\n}\r\n.returnContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n}\r\n.submitBtnsContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n}\r\n.returnBtn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  column-gap: 5px;\r\n  color: var(--focused-input-color);\r\n  fill: var(--focused-input-color);\r\n  border-radius: 9px;\r\n  padding: 5px 10px;\r\n  /* width: 80px;\r\n  height: 40px; */\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n  font-weight: 400;\r\n}\r\n.returnBtn svg {\r\n  width: 24px;\r\n  height: 24px;\r\n  transform: rotate(180deg);\r\n}\r\n.submitBtn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: var(--focused-input-color);\r\n  color: #ffffff;\r\n  fill: #ffffff;\r\n  border-radius: 9px;\r\n  padding: 12px 8px;\r\n  /* width: 80px;\r\n  height: 40px; */\r\n  min-width: 80px;\r\n  column-gap: 8px;\r\n  cursor: pointer;\r\n  position: relative;\r\n  overflow: hidden;\r\n  min-width: 125px;\r\n}\r\n.submitBtn:after {\r\n  background: #fff9f9;\r\n  content: \"\";\r\n  height: 155px;\r\n  left: -75px;\r\n  opacity: 0.2;\r\n  position: absolute;\r\n  top: -50px;\r\n  transform: rotate(35deg);\r\n  transition: all 1s cubic-bezier(0.19, 1, 0.22, 1);\r\n  width: 50px;\r\n  z-index: 0;\r\n}\r\n\r\n.submitBtn:hover:after {\r\n  left: 120%;\r\n  transition: all 1s cubic-bezier(0.19, 1, 0.22, 1);\r\n}\r\n.submitTxt {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n}\r\n.sendAgainTxt {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n}\r\n.submitBtn svg {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n.otpAbsolutePosition {\r\n  position: absolute !important;\r\n  top: 0 !important;\r\n  right: 0 !important;\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n}\r\n.otpContainer {\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  flex-direction: column !important;\r\n  row-gap: 20px !important;\r\n}\r\n.otpMounted {\r\n  animation: otpIn 350ms ease-in;\r\n}\r\n.otpUnmounted {\r\n  animation: otpOut 390ms ease-out forwards;\r\n}\r\n@keyframes otpOut {\r\n  0% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n}\r\n@keyframes otpIn {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n.countDownContainer {\r\n  padding-inline-end: 12px;\r\n  color: #737373;\r\n}\r\n.progress {\r\n  width: 24px !important;\r\n  height: 24px !important;\r\n  color: #fff !important;\r\n}\r\n@media all and (max-width: 900px) {\r\n  .welcomeTitle {\r\n    padding-block-end: 70px;\r\n    font-size: 48px;\r\n  }\r\n  .formPart {\r\n    justify-content: flex-end !important;\r\n  }\r\n}\r\n@media all and (max-width: 600px) {\r\n  .formPart {\r\n    justify-content: center !important;\r\n  }\r\n  .carouselPart {\r\n    /* display: none !important; */\r\n    position: fixed !important;\r\n    top: 0;\r\n    right: 0;\r\n    z-index: -1;\r\n  }\r\n  .welcomeTitle {\r\n    padding-block-end: 60px;\r\n    font-weight: 700;\r\n    font-size: 40px;\r\n  }\r\n  .welcomeText {\r\n    font-size: 18px;\r\n    padding-block-end: 24px;\r\n  }\r\n  .borderedContainer {\r\n    background-color: #ffffffe5;\r\n    padding-block: 70px;\r\n    padding-inline: 20px;\r\n  }\r\n  .container {\r\n    padding-inline: 0 !important;\r\n  }\r\n  .submitBtn {\r\n    min-width: 120;\r\n  }\r\n}\r\n@media all and (max-width: 400px) {\r\n  .welcomeTitle {\r\n    padding-block-end: 40px;\r\n    font-weight: 700;\r\n    font-size: 32px;\r\n  }\r\n  .welcomeText {\r\n    font-size: 16px;\r\n    padding-block-end: 20px;\r\n  }\r\n  .submitBtn {\r\n    min-width: 100px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rootContainer": `Login_rootContainer__peznh`,
	"container": `Login_container__YLBHG`,
	"carouselPart": `Login_carouselPart__P20zU`,
	"carouselContainer": `Login_carouselContainer__6jBlf`,
	"formPart": `Login_formPart__3iTvF`,
	"borderedContainer": `Login_borderedContainer__6KWGe`,
	"loginInfosContainer": `Login_loginInfosContainer__lqR6u`,
	"formWrapper": `Login_formWrapper__6-F46`,
	"welcomeTitle": `Login_welcomeTitle__H5oZ5`,
	"welcomeText": `Login_welcomeText__8zTrN`,
	"inputContainer": `Login_inputContainer__VBrGJ`,
	"submitGrid": `Login_submitGrid__Pvf7e`,
	"loginReqBtnContainer": `Login_loginReqBtnContainer__kRSTt`,
	"actionBtnsContainer": `Login_actionBtnsContainer__xCKyL`,
	"returnContainer": `Login_returnContainer__+eOCD`,
	"submitBtnsContainer": `Login_submitBtnsContainer__VYDc4`,
	"returnBtn": `Login_returnBtn__lh2UF`,
	"submitBtn": `Login_submitBtn__5ZKOw`,
	"submitTxt": `Login_submitTxt__z1Im8`,
	"sendAgainTxt": `Login_sendAgainTxt__ku0S3`,
	"otpAbsolutePosition": `Login_otpAbsolutePosition__x9bDc`,
	"otpContainer": `Login_otpContainer__28HNE`,
	"otpMounted": `Login_otpMounted__+Izmu`,
	"otpIn": `Login_otpIn__0ZZrD`,
	"otpUnmounted": `Login_otpUnmounted__D+cRM`,
	"otpOut": `Login_otpOut__i7Im2`,
	"countDownContainer": `Login_countDownContainer__QTU-p`,
	"progress": `Login_progress__98HmO`
};
export default ___CSS_LOADER_EXPORT___;
